"use client"

import React from "react"
import { NotificationItemTemplate } from "./NotificationItemTemplate"
import { FragmentType, graphql, useFragment } from "@/gql"
import { NotificationActor } from "./NotificationActor"
import { Text } from "@/elements"
import { useRouter } from "next-nprogress-bar"
import { UserNotificationFeedItem } from "@/gql/graphql"

const CreativeWorkProjectLikeFragment = graphql(`
  fragment JobInvitationReceived on StreamNotificationFeedAggregatedActivity {
    id
    isSeen
    activities {
      id
      time
      target {
        __typename
        ... on JobPosting {
          id
          position {
            id
            name
          }
        }
      }
      foreignObject {
        __typename
        ... on JobInvitation {
          id
        }
      }
      actor {
        id
        name
        ...NotificationActor
      }
    }
  }
`)

interface Props {
  onActorClick: (e: React.MouseEvent<any, MouseEvent>) => void
  item: FragmentType<typeof CreativeWorkProjectLikeFragment>
  onClick: (type: UserNotificationFeedItem) => void
}

export const JobInvitationReceived: React.FC<Props> = props => {
  const { onActorClick, onClick } = props
  const router = useRouter()
  const item = useFragment(CreativeWorkProjectLikeFragment, props.item)
  const activities = item.activities?.[0]
  const actor = activities?.actor
  const actorName = actor?.name
  const target =
    activities?.target?.__typename === "ClientJobPosting" || activities?.target?.__typename === "CreativeJobPosting"
      ? activities?.target
      : null

  const categoryName = target?.position?.name

  const handleClick = () => {
    onClick(UserNotificationFeedItem.JobInvitationReceived)
    router.push(`/jobs/${target?.id}`)
  }

  return (
    <NotificationItemTemplate
      isSeen={item.isSeen}
      onClick={handleClick}
      LeftComponent={actor && <NotificationActor actor={actor} onActorClick={onActorClick} />}
      TextContent={
        <Text element="span">
          <Text element="span" onClick={onActorClick} className="!font-medium">
            {actorName ?? "Member"}
          </Text>{" "}
          has invited you to apply to an open{" "}
          {categoryName && (
            <Text element="span" className="!font-medium">
              {categoryName}{" "}
            </Text>
          )}
          position.
        </Text>
      }
      time={activities?.time}
    />
  )
}
